export enum LogRecordType {
  ALL,
  CRASHLYTICS,
  CLEAVER_TAP,
}

export enum LogSeverityType {
  TRACE,
  INFO,
  DEBUG,
  ERROR,
}

const LogLevels = {
  DEBUG: 'DEBUG',
  INFO: 'INFO',
  WARN: 'WARN',
  ERROR: 'ERROR',
  CRITICAL: 'CRITICAL',
  NONE: 'NONE',
};

export interface Log {
  recordType: LogRecordType;
  severity: LogSeverityType;
  error?: any;
  tag?: string;
}

const UILogger = {
  info: (...args: any) => {
    console.log(args);
  },
  debug: (...args: any) => {
    console.log(args);
  },
  log: (...args: any) => {
    console.log(args);
  },
  error: (...args: any) => {
    console.log(args);
  },
};

export default UILogger;
